import groq from 'groq'
import { mediaAsset } from './mediaAsset.js'
import { faqItems } from '../projections/faqItems.js'

export const postBodyFields = groq`
    _type == 'quoteBlock' => {
      text,
      author
    },
    _type == 'takeawayBlock' => {
      title,
      text
    },
    _type == 'interviewBlock' => {
      segments[]{
        text,
        "person": person->{
          name,
          role,
          media[]{
            ...${mediaAsset()}
          }
        }
      }
    },
    _type == 'faqItems' => {
      ${faqItems}
    },
    _type == 'table' => {
      rows
    },
`
